import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import {
  DocumentsComponent,
  DocumentsService,
  GungModalService,
  Document,
  Customer,
  AuthService,
  SelectedCustomerService
} from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { User } from 'gung-standard/lib/state/auth/types';
import { forkJoin, Observable } from 'rxjs';
import { filter, first, map } from 'rxjs';

@Component({
  selector: 'tylo-documents-list',
  templateUrl: './tylo-documents-list.component.html',
  styleUrls: ['./tylo-documents-list.component.css']
})
export class TyloDocumentsListComponent extends DocumentsComponent {
  constructor(
    protected documentsService: DocumentsService,
    protected modalService: NgbModal,
    protected gungModalService: GungModalService,
    protected translateService: TranslateService,
    public dateUtilService: DateUtilService,
    protected authService: AuthService,
    protected selectedCustomerService: SelectedCustomerService
  ) {
    super(documentsService, modalService, gungModalService, translateService, dateUtilService);
  }

  protected getAllDocuments(nocache?: boolean): Observable<Document[]> {
    return forkJoin({
      user: this.authService.getCurrentUser().pipe(first()),
      documents: super.getAllDocuments(nocache).pipe(first()),
      customer: this.selectedCustomerService.getSelectedCustomer().pipe(
        filter(customer => !!customer),
        first()
      )
    }).pipe(
      first(),
      map(({ user, documents, customer }) => {
        return documents.filter(
          doc =>
            doc.metaData &&
            doc.metaData.inMenu &&
            (doc.metaData.inMenu === 'true' || doc.metaData.showInDocumentView === 'true') &&
            this.showDocumentExt(doc, user, customer)
        );
      })
    );
  }

  showDocumentExt(document, user: User, customer: Customer): boolean {
    let result = false;
    if (document && document.metaData && document.metaData.userGroups) {
      const currentUserKeys = Object.keys(user.activeGroups).filter(userGroup => user.activeGroups[userGroup] === true);
      if (document.metaData && document.metaData.userGroups && typeof document.metaData.userGroups === 'string') {
        document.metaData.userGroups = JSON.parse(document.metaData.userGroups);
      }
      const documentKeys = Object.keys(document.metaData.userGroups).find(
        userGroup => document.metaData.userGroups[userGroup] === true
      );
      const groupKey = Object.keys(document.metaData.userGroups).find(
        userGroup => document.metaData.userGroups[userGroup] === true && currentUserKeys.some(key => key === userGroup)
      );
      if (groupKey) {
        result = true;
      } else {
        result = false;
      }

      if (document.metaData.includedAssortments) {
        const assortmentList: string[] = document.metaData.includedAssortments.split(',');
        if (!assortmentList.includes(user.assortment)) {
          return false;
        }
      }
      if (!customer) {
        return false;
      }
      if (document.metaData.includedCustomers) {
        const customerList: string[] = document.metaData.includedCustomers.split(',');
        if (!customerList.includes(customer.id)) {
          return false;
        }
      }
      if (document.metaData.excludedCustomers) {
        const customerList: string[] = document.metaData.excludedCustomers.split(',');
        if (customerList.includes(customer.id)) {
          return false;
        }
      }
    }
    return result;
  }
}
